import type { PromoCampaignErrorRow } from '../model/types'

export default async function buildPromoErrorFileBlob(
	rows: PromoCampaignErrorRow[]
): Promise<Blob> {
	const Excel = await import('exceljs')
	const workbook = new Excel.Workbook()
	workbook.creator = 'Competera Validator'
	workbook.lastModifiedBy = 'Competera Validator'
	workbook.created = new Date()
	workbook.modified = new Date()
	workbook.lastPrinted = new Date()
	const worksheet = workbook.addWorksheet('Sheet1')
	worksheet.columns = [
		{ header: 'SKU', key: 'sku', width: 50, outlineLevel: 1 },
		{ header: 'Pricing tier id', key: 'pricing_tier_id', width: 50 },
		{ header: 'Reason', key: 'reason', width: 50 },
	]
	worksheet.addRows(rows)
	const buffer = await workbook.xlsx.writeBuffer()

	return new Blob([buffer], {
		type: 'application/octet-binary;charset=utf-8',
	})
}
